/**
 * Promise.prototype.finally polyfill
 *
 * Adds .finally() method to Promise if it doesn't exist.
 * This ensures compatibility with older browsers and promise polyfills
 * that don't implement the finally method (added in ES2018).
 */

(function() {
  if (typeof Promise !== 'undefined' && !Promise.prototype.finally) {
    Promise.prototype.finally = function(callback) {
      const constructor = this.constructor;

      return this.then(
        function(value) {
          return constructor.resolve(callback()).then(function() {
            return value;
          });
        },
        function(reason) {
          return constructor.resolve(callback()).then(function() {
            throw reason;
          });
        }
      );
    };
  }

  if (typeof Promise !== 'undefined' && !Promise.allSettled) {
    Promise.allSettled = function(iterable) {
      var values;
      try {
        if (typeof Array.from !== 'undefined') {
          values = Array.from(iterable);
        } else {
          values = [];
          for (var i = 0; i < iterable.length; i++) {
            values.push(iterable[i]);
          }
        }
      } catch (error) {
        return Promise.reject(error);
      }
      return Promise.all(
        values.map(function(promiseLike) {
          return Promise.resolve(promiseLike).then(
            function(value) {
              return { status: 'fulfilled', value: value };
            },
            function(reason) {
              return { status: 'rejected', reason: reason };
            }
          );
        })
      );
    };
  }
})();
